import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    height: 'calc(100vh - 60px)',
    padding: '15px 15px 60px',
  },
});

export default useStyles;
